import backgroundPrintFunc from "pxc-editor-material-svg-rendering/backgroundPrintFunc";
import { PRINTING_MODE } from 'pxc-editor-material-svg-rendering/constants';
import { INTERACTION_MODE } from 'pxc-editor-material-svg-rendering/constants';
import { generateDataToDownload } from 'pxc-editor-web/environment_modules/xcore/helpers/presenter';
import {
  handleEventFileUpload,
  getWizardData
} from '@/helpers';
import { setLastSavedPages } from '@/actions/page';
import { setShowLoader, setFromWizardState } from '@/actions/main';
import { autofillProjectFromWizardData } from '@/actions/autofill';
import { uploadProject, setSavedProjectName } from "@/actions/project";
import { getBuildedMatfileTemplate } from "@/helpers/matfile";

import { requestSaveProject, sendAutoSavedProject } from '../external-store';
import { parseInitProjectData } from '../helpers/parser';
import { generateRequestOpenPrintDialogData } from '../helpers/presenter';
import { requestOpenPrintDialog } from '../external-store';
import { setModeActionThunk, setWizardData } from '../../../../pxc_editor_web/src/actions/main';

// XCORE use it with: matfile | matfile + project | matfile + wizard | matfile + project + wizard
export const handleRequestOpenProject = (data, openFrom, editor_mode) => (dispatch, getState) => {
  dispatch(setShowLoader(true));

  const parsedProjData = parseInitProjectData(data);
  const { core: { mode } } = getState();
  const wizardScopeData = parsedProjData?.wizard? parsedProjData.wizard : null;
  const shouldOpenWizard = mode !== INTERACTION_MODE.WIZARD && wizardScopeData?.application_type?.length && wizardScopeData?.application_type !== 'PATCH_PANEL';
  const callback = () => {
    const { project, wizard } = parsedProjData;
    if (shouldOpenWizard) {
      const wizardProjectData = getWizardData(wizard.data);
      wizard['data'] = wizardProjectData;
      dispatch(setWizardData(wizard));
      if (editor_mode === 'WIZARD') {
        dispatch(setModeActionThunk(INTERACTION_MODE.WIZARD));
      }
    } else {
      if (wizard) {
        // hier cable flag...
        dispatch(setFromWizardState(true));
        if (!project) {
          // wizard data can be applied only on creating of project
          dispatch(autofillProjectFromWizardData(wizard));
          if (openFrom === 'XCORE_PROJECTS') {
            dispatch(setLastSavedPages());
          }
        }
      }
    }
    setTimeout(() => {
      dispatch(setShowLoader(false));
      if (wizard?.start_print) {
        const { core: { pagesOrder, paginationPageNum } } = getState()
        if (pagesOrder.length) {
          dispatch(requestOpenPrintDialog(generateRequestOpenPrintDialogData({ totalPages: pagesOrder.length, currentPage: paginationPageNum })));
        }
      }
    }, 750);
  }

  dispatch(uploadProject({ projectData: parsedProjData, beforeFinishActionsClb: callback }));
};

export const handleSaveProjectClick = () => (dispatch) => {
  dispatch(setShowLoader(true));
  setTimeout(() => {
    dispatch(saveProject({
      requestSaveProject, 
      clb: () => (dispatch) => {
        dispatch(setShowLoader(false));
      }
    }));
  });
};

export const handleAutoSaveProject = () => (dispatch, getState) => {
  dispatch(saveProject({ sendAutoSavedProject }));
}

const saveProject = (payload) => (dispatch, getState) => {
  const { requestSaveProject, sendAutoSavedProject, clb } = payload;
  const {
    core: { 
      pagesOrder,
      pages,
      paperColor,
      isContentPlacingDebugging,
      isDebuggingGrid,
      projectName,
      snapshotPointer
    } 
  } = getState();
  const { printParameters: materialPrintParameters, type: materialType } = getBuildedMatfileTemplate();

  let previewImg = null;
  // first - build preview image
  backgroundPrintFunc(
    [ pagesOrder[0] ],
    { mode: PRINTING_MODE.PREVIEW, skipMaterialTransforms: true },
    { pages, materialPrintParameters, materialType, paperColor, isContentPlacingDebugging, isDebuggingGrid },
    // on image print - just save image to variable
    ({imageUrlData}) => { previewImg = imageUrlData },
    // on print finish - continue project downloading with image
    () => {
      const project = generateDataToDownload({ previewImg });

      if (project.project_metadata?.material_filename + '.meta' === project.file_name && project.project_metadata?.material_metadata?.name?.length) {
        project.file_name = project.project_metadata.material_metadata.name;
      }
      if (requestSaveProject) {
        requestSaveProject(project, dispatch, setSavedProjectName);
      }
      if (sendAutoSavedProject) {
        const isProjectEdited = projectName && snapshotPointer >= 0;
        sendAutoSavedProject(isProjectEdited ? project : null);
      }
      if (clb) {
        dispatch(clb());
      }
      
      dispatch(setLastSavedPages());
    }
  );
};

// DEVELOPMENT ONLY
export const handleMatfileUpload = syntheticEvent => (dispatch) => {
  dispatch(setShowLoader(true));
  handleEventFileUpload(syntheticEvent, (fileData, fileName) => {
    const parsedProjectData = parseInitProjectData({ material: { name: fileName, contents: fileData, is_base64: false } });

    dispatch(uploadProject({ projectData: parsedProjectData }));
    dispatch(setShowLoader(false));
  });
};
